import { MoonFilled, SunFilled } from '@ant-design/icons'
import { Horizontal, Texto } from '@gravitate-js/excalibrr'

export const AmPmLabel = ({ value }: { value?: 'am' | 'pm' }) => {
  if (!value) return <Texto>No Preference</Texto>
  return (
    <Horizontal gap={4} style={{ flexShrink: 0 }} alignItems='center'>
      {value === 'am' ? (
        <SunFilled style={{ color: 'var(--theme-warning)' }} />
      ) : (
        <MoonFilled style={{ color: 'var(--theme-color-2)' }} />
      )}
      <Texto>{value.toUpperCase()}</Texto>
    </Horizontal>
  )
}
